"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import renderBudget from "./render_budget_field";
export default class CustomFieldRendererOverride {
  constructor(customFieldsRenderer) {
    if (!customFieldsRenderer) {
      throw new Error("customFieldsRenderer is undefined");
    }
    this.renderer = customFieldsRenderer;
    this.rendererDataToXML = this.renderer.dataToXML;
    this.renderer.dataToXML = this.dataToXML.bind(this);
  }
  get $element() {
    return this.renderer.$element;
  }
  filterByType(data, matchType) {
    return data.filter(({ type }) => {
      return type === matchType;
    });
  }
  /**
   * Takes JSON object data, and transform it in a XML document (valid HTML string)
   * This methods uses only dd, dt, and div tags to be compatible with decidim sanitization.
   *
   * @param {Object} data
   * @returns {Promise<string>} String to save the field and render it in the proposal body without further computation.
   */
  dataToXML(data) {
    return __async(this, null, function* () {
      const budgetData = this.filterByType(data, "budget");
      const attachFileData = this.filterByType(data, "attachFile");
      yield Promise.all(
        attachFileData.map((field) => __async(this, null, function* () {
          const { userData, name } = field;
          if (userData && userData.length > 0) {
            return;
          }
          const $input = $(`input[name="${name}"]`);
          if ($input.prop("type") === "file") {
            const url = yield this.uploadFile(name);
            if (url) {
              field.userData = [url];
              field.value = url;
            }
          }
        }))
      );
      const $xml = $(this.rendererDataToXML(data));
      budgetData.forEach((field) => {
        const fieldId = field.name;
        const $dd = $xml.find(`dd#${fieldId} > div`);
        $dd.html(renderBudget(field.userData, field));
      });
      return $xml.html();
    });
  }
  uploadFile(inputName) {
    return __async(this, null, function* () {
      const $input = $(`input[name="${inputName}"]`);
      if (!$input.attr("type") === "file") {
        throw new Error(`input[name="${inputName}"] is not a file input.`);
      }
      const file = $input.prop("files")[0];
      if (!file) {
        console.warn(`input[name="${inputName}"] has no file, skipping upload`);
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      return yield new Promise((resolve, reject) => {
        $.ajax({
          url: "/editor_files",
          type: "POST",
          cache: false,
          data: formData,
          dataType: "json",
          jsonp: false,
          processData: false,
          contentType: false,
          async: false,
          headers: { "X-CSRF-Token": this.csrfToken() }
        }).done((resp) => {
          const { url = "" } = resp;
          if (!url) {
            resolve(null);
          } else {
            resolve(url);
          }
        }).fail(reject);
      });
    });
  }
  csrfToken() {
    return $('meta[name="csrf-token"]').attr("content");
  }
  /**
   * Defer to CustomFieldsRenderer#fixBuggyFields
   */
  fixBuggyFields() {
    return this.renderer.fixBuggyFields();
  }
  /**
   * Overrides CustomFieldsRenderer#storeData to
   * allow dataToXML to be async.
   */
  storeData() {
    return __async(this, null, function* () {
      if (!this.renderer.$element) {
        return false;
      }
      const $form = this.renderer.$element.closest("form");
      const $body = $form.find(
        `input[name="${this.renderer.$element.data("name")}"]`
      );
      if ($body.length && this.renderer.instance) {
        this.renderer.spec = this.renderer.instance.userData;
        $body.val(yield this.dataToXML(this.renderer.spec));
        this.renderer.$element.data("spec", this.renderer.spec);
      }
      console.log(
        "storeData spec",
        this.spec,
        "$body",
        $body,
        "$form",
        $form,
        "this",
        this
      );
      return this;
    });
  }
  /**
   * Defer to CustomFieldsRenderer#init
   */
  init($element) {
    return this.renderer.init($element);
  }
}
